import service from '@/store/services/bonus-sevice';
// import {logEvent} from "firebase/analytics";

const state = {
    listCountry: {},
    defaultStartBonusClient: {},
    updateDefaultBonusSettings: {},
    addNewCountryCredits: {},
    listCountryCredits: {},
    deleteCountryCredits: {},
    testorderinfo: {},
    testorderupdate: {},
    massStartBonusUpdate: {}

};

const mutations = {
    SET_LIST_COUNTRY: (state, listCountry) => {
        state.listCountry = listCountry;
    },
    // SET_DEFAULT_START_BONUS: (state, defaultStartBonusClient) => {
    //     state.defaultStartBonusClient = defaultStartBonusClient;
    // },
    SET_DEFAULT_BONUS_SETTINGS: (state, updateDefaultBonusSettings) => {
        state.updateDefaultBonusSettings = updateDefaultBonusSettings;
    },
    SET_ADD_NEW_COUNTRY_CREDITS: (state, addNewCountryCredits) => {
        state.addNewCountryCredits = addNewCountryCredits;
    },
    SET_LIST_COUNTRY_CREDITS: (state, listCountryCredits) => {
        state.listCountryCredits = listCountryCredits;
    },
    SET_DELETE_COUNTRY_CREDITS: (state, deleteCountryCredits) => {
        state.deleteCountryCredits = deleteCountryCredits;
    },
    SET_TEST_ORDER_INFO: (state, testorderinfo) => {
        state.testorderinfo = testorderinfo;
    },
    SET_TEST_ORDER_UPDATE: (state, testorderupdate) => {
        state.testorderupdate = testorderupdate;
    },
    SET_MASS_START_BONUS_UPDATE: (state, massStartBonusUpdate) => {
        state.massStartBonusUpdate = massStartBonusUpdate;
    },
};

const actions = {
    listCountry({commit, dispatch}, params) {
        return service.listCountry(params)
            .then(({listCountry}) => {
                commit('SET_LIST_COUNTRY', listCountry);
            });
    },

    async defaultBonusSettings({commit}) {
        return service.defaultBonusSettings()
            .then((defaultBonusSettings) => {
                commit('SET_DEFAULT_BONUS_SETTINGS', defaultBonusSettings);
            });
    },

    async updateDefaultSetting({commit, dispatch}, params) {
        return await service.updateDefaultSetting(params);
    },

    addNewCountryCredits({commit, dispatch}, params) {
        return service.addNewCountryCredits(params).then((addNewCountryCredits) => {
            commit('SET_ADD_NEW_COUNTRY_CREDITS', addNewCountryCredits);
        });
    },
    listCountryCredits({commit, dispatch}, params) {
        return service.listCountryCredits(params)
            .then(({listCountryCredits}) => {
                commit('SET_LIST_COUNTRY_CREDITS', listCountryCredits);
            });
    },
    deleteCountryCredits({commit, dispatch}, params) {
        return service.deleteCountryCredits(params).then((deleteCountryCredits) => {
            commit('SET_DELETE_COUNTRY_CREDITS', deleteCountryCredits);
        });
    },
    testorderinfo({commit, dispatch}, params) {
        return service.getTestOrderInfo(params)
            .then(({testorderinfo}) => {
                commit('SET_TEST_ORDER_INFO', testorderinfo);
            });
    },
    testorderupdate({commit, dispatch}, params) {
        return service.updateTestOrderInfo(params)
            .then(({testorderupdate}) => {
                commit('SET_TEST_ORDER_UPDATE', testorderupdate);
            });
    },
    massStartBonusUpdate({commit, dispatch}, params) {
        return service.massStartBonusUpdate(params)
            .then(({massStartBonusUpdate}) => {
                commit('SET_MASS_START_BONUS_UPDATE', massStartBonusUpdate);
            });
    },
};

const getters = {
    listCountry: state => state.listCountry,
    // defaultStartBonusClient: state => state.defaultStartBonusClient,
    defaultBonusSettings: state => state.updateDefaultBonusSettings,
    addNewCountryCredits: state => state.addNewCountryCredits,
    listCountryCredits: state => state.listCountryCredits,
    deleteCountryCredits: state => state.deleteCountryCredits,
    testorderinfo: state => state.testorderinfo,
    testorderupdate: state => state.testorderupdate,
    massStartBonusUpdate: state => state.massStartBonusUpdate

};

const startBonus = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default startBonus;